import * as React from 'react';

const StorePickupLine: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" focusable="false" width="28" height="26" viewBox="0 0 28 26">
            <path d="M2 11.3c0-.2.1-.5.2-.7l3-5.6c.3-.6 1-1 1.6-1h15.3c.7 0 1.3.4 1.6 1l3 5.6c.3.2.3.4.3.7 0 .8-.7 1.5-1.5 1.5h-1v10.6c0 .4-.3.6-.6.6s-.6-.3-.6-.6V12.8H5.8v5h10V14H17v8.1c0 1-.8 1.9-1.9 1.9H6.4c-1 0-1.9-.8-1.9-1.9v-9.4h-1c-.8.1-1.5-.6-1.5-1.4zm3.1.2h20.4c.1 0 .2-.1.2-.2v-.1l-3-5.6c-.1-.2-.3-.3-.6-.3H6.9c-.2 0-.4.1-.6.3l-3 5.6v.1c0 .1.1.2.2.2h1.6zm.7 10.7c0 .4.3.6.6.6h8.8c.4 0 .6-.3.6-.6V19h-10v3.2z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(StorePickupLine);
